<template>
    <ApolloQuery :query="gql => gql`
                query HelpItemQuery ($id: ID!) {
                      helpItem(id: $id) {
                        title
                        body
                      }
                }
              `"
                 :variables="{ id }"
                 class="help-item-detail"
    >
        <template slot-scope="{result: {loading, data, error}, isLoading}">
            <!--<editor-fold desc="skeleton">-->
            <ion-card v-if="isLoading">
                <ion-card-header>
                    <ion-card-title>
                        <ion-skeleton-text animated style="height: 30px; width: 55%;"></ion-skeleton-text>
                    </ion-card-title>
                </ion-card-header>
                <ion-card-content>
                    <ion-skeleton-text animated style="height: 20px;"></ion-skeleton-text>
                    <ion-skeleton-text animated style="height: 20px;"></ion-skeleton-text>
                    <ion-skeleton-text animated style="height: 20px; width: 80%;"></ion-skeleton-text>
                    <ion-skeleton-text animated style="height: 20px; width: 60%;"></ion-skeleton-text>
                </ion-card-content>
            </ion-card>
            <!--</editor-fold>-->

            <ion-card v-else-if="error" class="error apollo">
                <ion-card-header>
                    <ion-card-title>{{ $t('ncrypt.something_went_wrong') }}</ion-card-title>
                </ion-card-header>
                <ion-card-content>{{ error }}</ion-card-content>
            </ion-card>

            <ion-card v-else-if="data && data.helpItem">
                <ion-card-header>
                    <ion-card-title>{{ data.helpItem.title }}</ion-card-title>
                </ion-card-header>
                <ion-card-content v-html="data.helpItem.body"></ion-card-content>
            </ion-card>

            <ion-card v-else class="no-result apollo">
                <ion-card-header>
                    <ion-card-title>{{ $t('ncrypt.not_found_singular') }}</ion-card-title>
                </ion-card-header>
                <ion-card-content>{{ $t('ncrypt.help_page.article_not_found') }}</ion-card-content>
            </ion-card>
        </template>
    </ApolloQuery>
</template>

<script>
    export default {
        name: "HelpItem",
        props: {
            id: {type: Number},
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .help-item-detail {
        figure {
            width: 600px;
            max-width: 85%;
            margin: 1em 0;
            img {
                width: auto;
            }
        }
        figcaption {
            display: none;
        }
    }
</style>
